var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownNarrow = function SvgArrowDownNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.743 10.293 6.45 12.586V1a1 1 0 1 0-2 0v11.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l4 4q.035.035.073.066l.036.027q.02.016.043.031.021.014.043.027l.04.024.046.022.043.02.045.016.048.017.045.011q.024.008.05.012.026.005.052.009l.044.006q.099.009.198 0l.043-.006q.027-.004.053-.009t.05-.012l.045-.011.048-.017.044-.016.044-.02.045-.022.04-.024q.023-.013.044-.027l.043-.031.036-.027a1 1 0 0 0 .072-.065v-.001l4-4a1 1 0 1 0-1.413-1.414",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDownNarrow;